import { useCallback, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #3354 -- admin sets the rider and/or test of an emergency manual ride
// (score-api PUT /ride/:rideId/details). A manual ride is created with
// free-text names only, so without a riderId the rider portal can never find
// it. Body is { riderId?, testId? }; the server audits the change.
export function useSetManualRideDetails() {
  const scoreApi = useScoreApi();
  const [saving, setSaving] = useState(false);

  const setDetails = useCallback(
    async (rideId, details) => {
      setSaving(true);
      try {
        return unwrap(await scoreApi.rides.setManualRideDetails(rideId, details));
      } finally {
        setSaving(false);
      }
    },
    [scoreApi],
  );

  return { setDetails, saving };
}

export default useSetManualRideDetails;
